export const UNSET_ENTRY_POINT = Symbol('unset_entry_point');
